<template>
  <div class="nkn-advisor">
    <div class="nkn-adviser-body">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6">
        <adviser-module>
          <img v-lazy="'/static/img/about/adviser/diffie.png'" slot="portrait" class="pic-adviser-diffie">
          <a slot="fullname" :href="$url.ADVISER_LINK.diffie" target="_blank">{{$t("about.member.diffle.name")}}</a>
          <div slot="honor">{{$t("about.member.diffle.honor1")}}</div>
          <div slot="honor">{{$t("about.member.diffle.honor2")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row1")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row2")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row3")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row4")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row5")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row6")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row7")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row8")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row9")}}</div>
        </adviser-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 adviser-Wolfram">
        <adviser-module>
          <img v-lazy="'/static/img/about/adviser/Wolfram.png'" slot="portrait" class="pic-adviser-Wolfram">
          <a slot="fullname" :href="$url.ADVISER_LINK.wolfram" target="_blank">{{$t("about.member.wolfram.name")}}</a>
          <div slot="honor">{{$t("about.member.wolfram.honor1")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row1")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row2")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row3")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row4")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row5")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row6")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row7")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row8")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row9")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row10")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row11")}}</div>
        </adviser-module>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import AdviserModule from '@/components/about/plugins/AdviserModule'
export default {
  components: {
    AdviserModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-advisor{
  @include common-inner();
  .nkn-adviser-body {
    padding-right: .9rem;
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/nknAdvisor.vue